import React from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import glamorous from "glamorous";
import { Card } from "react-toolbox/lib/card";
import { withLoading } from "../../../../../../redux-modules/loading-overlay";
import CustomerActions from "../../../../actions/customers";
import LegislatorsActions from "../../../../actions/legislators";
import {
  fillableDefaults,
  fillWithDefaults
} from "../../../../utils/defaultDataHelper";
import AddressForm, {
  SameAsBusinessCheckbox,
  renderAddressHeader
} from "../../../AddressForm";
import OnboardingNavigation from "../../OnboardingNavigation";
import { StepHeader } from "../index";

const AddressFormCard = glamorous(Card)({
  padding: "1.4rem 1.6rem",
  overflow: "visible",
  boxShadow: "none !important"
});

const SkipButton = glamorous.a({
  display: "inline-block",
  textDecoration: "underline",
  marginTop: "3rem",
  fontStyle: "italic",
  fontSize: "1.5rem",
  cursor: "pointer",
  textTransform: "lowercase"
});

class HomeAddress extends React.Component {
  static propTypes = {
    toggleView: PropTypes.func,
    isLoading: PropTypes.bool,
    currentCustomer: PropTypes.shape({
      personalAddress: PropTypes.shape({
        addressLine1: PropTypes.string,
        addressLine2: PropTypes.string,
        city: PropTypes.string,
        countryCode: PropTypes.string,
        county: PropTypes.string,
        stateCode: PropTypes.string,
        postalCode: PropTypes.string
      })
    }),
    currentOrganization: PropTypes.shape({
      addresses: PropTypes.arrayOf(
        PropTypes.shape({
          addressLine1: PropTypes.string,
          addressLine2: PropTypes.string,
          city: PropTypes.string,
          countryCode: PropTypes.string,
          county: PropTypes.string,
          stateCode: PropTypes.string,
          postalCode: PropTypes.string
        })
      )
    }),
    actions: PropTypes.shape({
      customer: PropTypes.objectOf(PropTypes.func),
      legislators: PropTypes.objectOf(PropTypes.func)
    })
  };
  state = {
    forceReload: true,
    sameAsBusiness: false,
    isActive: true,
    addressData: {
      addresses: [
        {
          type: "Home",
          ...fillableDefaults.address
        }
      ]
    }
  };

  constructor(props) {
    super(props);
    this.state = {
      // ...this.state,
      addressData: this.loadAddressFromProps(this.state.sameAsBusiness, props)
    };
  }

  componentDidUpdate(nextProps) {
    if (nextProps.isLoading) {
      return;
      // ^^^ needs refactor or removal?
    }
    this.setState(prevState => ({
      ...prevState,
      addressData: this.loadAddressFromProps(
        prevState.sameAsBusiness,
        nextProps
      )
    }));
  }

  loadAddressFromProps = (sameAsBusiness, props) => {
    const { currentCustomer, currentOrganization } = props;
    let org;
    if (currentOrganization) {
      org = fillWithDefaults({
        containingObject: currentOrganization,
        fillType: "address",
        propName: "addresses",
        typeList: ["Business"]
      });
    }

    const businessAddress = ((org || {}).addresses || []).find(
      address => address.type.toLowerCase() === "business"
    ) || {
      ...fillableDefaults.address,
      type: "Business"
    };
    const homeAddress = (currentCustomer || {}).personalAddress || {
      ...fillableDefaults.address,
      type: "Home"
    };

    const address = sameAsBusiness ? businessAddress : homeAddress;

    return {
      addresses: [address]
    };
  };

  handleSameAsBusinessCheck = value => {
    return this.setState(prevState => ({
      ...prevState,
      forceReload: true,
      sameAsBusiness: value,
      addressData: this.loadAddressFromProps(value, this.props)
    }));
  };

  handleSave = ({ addresses }, isDirty) => {
    this.setState(prevState => ({
      ...prevState,
      forceReload: false
    }));

    const { toggleView, currentCustomer } = this.props;
    const { sameAsBusiness } = this.state;
    const { key } = currentCustomer || {};

    const requestBody = {
      key,
      personalAddress: {
        ...addresses[0],
        type: "Home"
      }
    };

    if (!isDirty && !sameAsBusiness) {
      // if no changes, we'll go to rep list
      toggleView("RepList");
      return true; // <-- refactor needed
    }

    return this.props.actions.customer.put(requestBody).then(results => {
      const { payload: { resp } = {} } = results;
      if (resp && resp.ok) {
        // if successful, we'll clear any existing reps and go to rep list
        this.props.actions.legislators.clear();
        return toggleView("RepList"); // <-- refactor needed
      } else {
        return results; // <-- refactor needed
      }
    });
  };

  renderHeader = renderAddressHeader("Home");

  renderNav = () => {
    const { goBack, toggleView, ...restProps } = this.props;
    return (
      <div style={{ textAlign: "center" }}>
        <OnboardingNavigation
          {...restProps}
          goForward={null}
          goBack={goBack}
          submitOnNext
        />
        <SkipButton onClick={() => toggleView("Continue")}>Skip</SkipButton>
      </div>
    );
  };

  render() {
    const { sameAsBusiness, forceReload, addressData } = this.state;
    const {
      pageColor: { value: color }
    } = this.props;
    const requiredFields = ["addressLine1", "city", "stateCode", "postalCode"];

    return (
      <div>
        <StepHeader>
          Fill out your home address, and we'll find your representatives.{" "}
        </StepHeader>
        <AddressForm
          FormWrapper={AddressFormCard}
          addressData={addressData}
          required={{
            Home: requiredFields,
            Business: requiredFields
          }}
          listenToState
          pageColor={color}
          handleSave={this.handleSave}
          forceReload={forceReload}
          renderSubmit={this.renderNav}
        >
          <SameAsBusinessCheckbox
            color={color}
            checked={sameAsBusiness}
            label="Same as Business"
            type="checkbox"
            onChange={this.handleSameAsBusinessCheck}
          />
        </AddressForm>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      customer: bindActionCreators(CustomerActions, dispatch),
      legislators: bindActionCreators(LegislatorsActions, dispatch)
    }
  };
};

export default connect(
  null,
  mapDispatchToProps
)(withLoading(HomeAddress));



// WEBPACK FOOTER //
// ./src/App/account/components/Onboarding/Steps/Representatives/HomeAddress.js